import { render, staticRenderFns } from "./DoTemplate.vue?vue&type=template&id=498f0e5b&scoped=true"
import script from "./DoTemplate.vue?vue&type=script&lang=js"
export * from "./DoTemplate.vue?vue&type=script&lang=js"
import style0 from "./DoTemplate.vue?vue&type=style&index=0&id=498f0e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f0e5b",
  null
  
)

export default component.exports